import { QRFC } from "./QRFC";

export class QLoadGuidesRFC extends QRFC {
  constructor() {
    super();
  }

  Init(callbackObj) {
    this.InitRemoteCall(callbackObj, "POST", true, false);
    this.SetAsync(true);
  }

  GetCallName() {
    return "guides/load";
  }

  SetParams(orgName, user) {
    this.AddParameter("org", orgName);
    this.AddParameter("user", user);
  }

  DoTransactionComplete(response, callBackObj) {
    const r = JSON.parse(response);
    callBackObj.HandleGuidesLoaded(r);
  }
}
